import * as ActionTypes from 'redux/actionTypes';

export function setSelectedProduct(selectedProduct){
    return {
        type: ActionTypes.SET_SELECTED_PRODUCT,
        selectedProduct,
    };
}

export function toggleMultiselectedProduct(selectedProduct){
    return {
        type: ActionTypes.TOGGLE_MULTISELECTED_PRODUCT,
        selectedProduct,
    };
}

export function setNewMultiselectedProducts(multiselectedProducts){
    return {
        type: ActionTypes.SET_MULTISELECTED_PRODUCTS,
        multiselectedProducts,
    };
}

export function setSelectedProductConfigurations(selectedProductConfigurations, pfid){
    return {
        type: ActionTypes.SET_SELECTED_PRODUCT_CONFIGURATIONS,
        selectedProductConfigurations,
        pfid,
    };
}

export function removeSelectedProductConfiguration(selectedProductConfigurationId, pfid) {
    return {
        type: ActionTypes.REMOVE_SELECTED_PRODUCT_CONFIGURATION,
        selectedProductConfigurationId,
        pfid,
    };
}

export function addUpload(uploadId, uploadUrl){
    return {
        type: ActionTypes.ADD_UPLOAD,
        uploadId,
        uploadUrl
    };
}

export function removeUpload(uploadId){
    return {
        type: ActionTypes.REMOVE_UPLOAD,
        uploadId,
    };
}

export function setSelectedTimezone(selectedTimezone) {
    return {
        type: ActionTypes.SET_SELECTED_TIMEZONE,
        selectedTimezone,
    };
}

export function setSelectedDate(selectedDate) {
    return {
        type: ActionTypes.SET_SELECTED_DATE,
        selectedDate,
    };
}

export function setSelectedTime(selectedTime) {
    return {
        type: ActionTypes.SET_SELECTED_TIME,
        selectedTime,
    };
}

export function setNote(note){
    return {
        type: ActionTypes.SET_NOTE,
        note,
    };
}

export function setSize(size){
    return {
        type: ActionTypes.SET_SIZE,
        size,
    };
}

export function setSocialMediaLink(socialMediaLink){
    return {
        type: ActionTypes.SET_SOCIAL_MEDIA_LINK,
        socialMediaLink,
    };
}

export function setName(name) {
    return {
        type: ActionTypes.SET_NAME,
        name,
    };
}

export function setEmail(email) {
    return {
        type: ActionTypes.SET_EMAIL,
        email,
    };
}

export function setPhone(phone) {
    return {
        type: ActionTypes.SET_PHONE,
        phone,
    };
}

export function setSelectedProductError(selectedProductError) {
    return {
        type: ActionTypes.SET_SELECTED_PRODUCT_ERROR,
        selectedProductError,
    };
}

export function setNoteError(noteError) {
    return {
        type: ActionTypes.SET_NOTE_ERROR,
        noteError,
    };
}

export function setSizeError(sizeError) {
    return {
        type: ActionTypes.SET_SIZE_ERROR,
        sizeError,
    };
}

export function setNameError(nameError) {
    return {
        type: ActionTypes.SET_NAME_ERROR,
        nameError,
    };
}

export function setEmailError(emailError) {
    return {
        type: ActionTypes.SET_EMAIL_ERROR,
        emailError,
    };
}

export function setPhoneError(phoneError) {
    return {
        type: ActionTypes.SET_PHONE_ERROR,
        phoneError,
    };
}

export function setNoteErrorsSuppressed(noteErrorsSuppressed) {
    return {
        type: ActionTypes.SET_NOTE_ERRORS_SUPPRESSED,
        noteErrorsSuppressed,
    };
}

export function setSizeErrorsSuppressed(sizeErrorsSuppressed) {
    return {
        type: ActionTypes.SET_SIZE_ERRORS_SUPPRESSED,
        sizeErrorsSuppressed,
    };
}

export function setNameErrorsSuppressed(nameErrorsSuppressed) {
    return {
        type: ActionTypes.SET_NAME_ERRORS_SUPPRESSED,
        nameErrorsSuppressed,
    };
}

export function setEmailErrorsSuppressed(emailErrorsSuppressed) {
    return {
        type: ActionTypes.SET_EMAIL_ERRORS_SUPPRESSED,
        emailErrorsSuppressed,
    };
}

export function setPhoneErrorsSuppressed(phoneErrorsSuppressed) {
    return {
        type: ActionTypes.SET_PHONE_ERRORS_SUPPRESSED,
        phoneErrorsSuppressed,
    };
}

export function setSelectedDesigner(selectedDesigner) {
    return {
        type: ActionTypes.SET_SELECTED_DESIGNER,
        selectedDesigner,
    };
}

export function setAvailableDatesSuccess(availableDates) {
    return {
        type: ActionTypes.SET_AVAILABLE_DATES_SUCCESS,
        availableDates,
    };
}

export function setAvailableDatesFailure(error) {
    return {
        type: ActionTypes.SET_AVAILABLE_DATES_FAILURE,
        error,
    };
}

export function setAvailableDatesLoading(loading) {
    return {
        type: ActionTypes.SET_AVAILABLE_DATES_LOADING,
        loading,
    };
}

export function setAvailableTimesSuccess(availableTimes) {
    return {
        type: ActionTypes.SET_AVAILABLE_TIMES_SUCCESS,
        availableTimes,
    };
}

export function setAvailableTimesFailure(error) {
    return {
        type: ActionTypes.SET_AVAILABLE_TIMES_FAILURE,
        error,
    };
}

export function setAvailableTimesLoading(loading) {
    return {
        type: ActionTypes.SET_AVAILABLE_TIMES_LOADING,
        loading,
    };
}

export function setOrderSubmitting(orderSubmitting) {
    return {
        type: ActionTypes.SET_ORDER_SUBMITTING,
        orderSubmitting,
    };
}

export function submitCoDesignOrderSuccess() {
    return {
        type: ActionTypes.SUBMIT_CO_DESIGN_ORDER_SUCCESS,
    };
}

export function submitCoDesignOrderFailure(error) {
    return {
        type: ActionTypes.SUBMIT_CO_DESIGN_ORDER_FAILURE,
        error,
    };
}

export function submitDifyOrderSuccess() {
    return {
        type: ActionTypes.SUBMIT_DIFY_ORDER_SUCCESS,
    };
}

export function submitDifyOrderFailure(error) {
    return {
        type: ActionTypes.SUBMIT_DIFY_ORDER_FAILURE,
        error,
    };
}

export function saveDifyOrderSuccess() {
    return {
        type: ActionTypes.SAVE_DIFY_ORDER_SUCCESS,
    };
}

export function saveDifyOrderFailure(error) {
    return {
        type: ActionTypes.SAVE_DIFY_ORDER_FAILURE,
        error,
    };
}

export function setCoDesignSelected(coDesignSelected) {
    return {
        type: ActionTypes.SET_CO_DESIGN_SELECTED,
        coDesignSelected,
    };
}

export function setDocumentPagePreviewModalVisible(documentPagePreviewModalVisible) {
    return {
        type: ActionTypes.SET_DOCUMENT_PAGE_PREVIEW_MODAL_VISIBLE,
        documentPagePreviewModalVisible,
    };
}

// documentPage is { altDocId, pageNumber }
export function setDocumentPagePreviewModalDocumentPage(documentPagePreviewModalDocumentPage) {
    return {
        type: ActionTypes.SET_DOCUMENT_PAGE_PREVIEW_MODAL_DOCUMENT_PAGE,
        documentPagePreviewModalDocumentPage,
    };
}




// WEBPACK FOOTER //
// ./src/redux/actionCreators.js